import React from 'react';
import { Box, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import {
    ReceiptLong as ReceiptLongIcon,
    CloudUpload as CloudUploadIcon,
    PieChart as PieChartIcon,
    Shield as ShieldIcon,
} from '@mui/icons-material';

function FeatureCard({ icon, title, desc }) {
    return (
        <Grid item xs={12} md={6}>
            <Card
                variant="outlined"
                sx={{
                    height: '100%',
                    borderRadius: 3,
                    transition: 'transform .15s ease, box-shadow .15s ease',
                    '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 12px 30px rgba(0,0,0,0.08)' },
                }}
            >
                <CardContent>
                    <Stack direction="row" alignItems="center" gap={1.5} sx={{ mb: 1 }}>
                        <Box
                            sx={{
                                width: 36,
                                height: 36,
                                borderRadius: 1.5,
                                bgcolor: 'rgba(255,165,0,0.2)',
                                display: 'grid',
                                placeItems: 'center',
                                color: 'orange',
                            }}
                        >
                            {icon}
                        </Box>
                        <Typography variant="h6" fontWeight={700}>
                            {title}
                        </Typography>
                    </Stack>
                    <Typography color="text.secondary">{desc}</Typography>
                </CardContent>
            </Card>
        </Grid>
    );
}

export default function LandingFeaturesSection() {
    return (
        <>
            <Typography variant="h4" align="center" fontWeight={800} gutterBottom>
                Warum Schreiberlein?
            </Typography>
            <Typography align="center" color="text.secondary" sx={{ mb: 4 }}>
                Konzentriere dich aufs Geschäft – wir kümmern uns um den Rest.
            </Typography>

            <Grid container spacing={3}>
                <FeatureCard
                    icon={<ReceiptLongIcon />}
                    title="Rechnungen & Angebote"
                    desc="Nummernkreis, Rabatte und Kleinunternehmer-Hinweis."
                />
                <FeatureCard
                    icon={<CloudUploadIcon />}
                    title="Belege in Sekunden"
                    desc="PDF hochladen oder Foto – wir erkennen Datum, Beträge, IBAN & Steuersätze automatisch."
                />
                <FeatureCard
                    icon={<PieChartIcon />}
                    title="Auswertungen"
                    desc="USt-Voranmeldung, USt-Jahreserklärung, einfache ESt-Übersicht – klar und nachvollziehbar."
                />
                <FeatureCard
                    icon={<ShieldIcon />}
                    title="Sicher & DSGVO-konform"
                    desc="Verschlüsselte Speicherung auf EU-Servern. Deine Daten gehören dir."
                />
            </Grid>
        </>
    );
}
